module.exports = __webpack_public_path__ + "static/img/mac_left.4260b27.png";


//////////////////
// WEBPACK FOOTER
// ./static/mac_left.png
// module id = j3Wf
// module chunks = 1